import { useState } from "react";
import styles from "./RegisterComponent.module.css";
import { FaChevronLeft, FaChevronRight, FaInfoCircle } from "react-icons/fa";
import { FormCheck } from "react-bootstrap";

const CompanyTypeCards = ({ data, setData, fieldErrors }) => {

    const [active, setActive] = useState(1);
    const companyTypes = [
        {
            id: 1,
            title: "Privatkunde und Kleingewerbe",
            desc: "In unserem Energiepool kontrollieren wir für Sie regelmäsig dem Markt und übernehmen Ihren Lieferantenwechsel.",
            foot: "- bis auf Wiederruf, auf Wunsch ein Leben lang.",
            type: "person",
            x_is_house_management: false,
        },
        {
            id: 2,
            title: "Hausverwaltung",
            desc: "Wir bündeln den Allgemeinstrom sowie Heizgas in unserem Energiepool. Durch das große Energievolumen profitieren alle von der jährlich durchgeführten gemeinsamen Energievergabe.",
            foot: "Liefern Sie Ihren Bewohnern und sich selbst einen Mehrwert.",
            type: "company",
            x_is_house_management: true,
        },
        {
            id: 3,
            title: "Gewerbetreibend",
            desc: "In unserem Energiepool kümmern wir uns um Ihre Energielieferverträge, machen jährliche Preisvergleiche und wechseln für Sie den Lieferanten.",
            foot: "Wir sind ausschließlich unseren Kund:innen verpflichtet.",
            type: "company",
            x_is_house_management: false,
        },
    ];


    const getClassName = (id) => {
        if (id === active) return `${styles.cardItem} ${styles.active}`;
        if (id === active - 1 || (active === 1 && id === companyTypes.length))
            return `${styles.cardItem} ${styles.left}`;
        if (id === active + 1 || (active === companyTypes.length && id === 1))
            return `${styles.cardItem} ${styles.right}`;
        return `${styles.cardItem} ${styles.hidden}`;
    };

    const checkboxHandler = (checked, type) => {
        if (checked === true) {
            setData(prev => ({...prev,
                company_type: type.type,
                x_is_house_management: type.x_is_house_management
            }));
        } else {
            setData(prev => ({...prev,
                    company_type: "",
                    x_is_house_management: false
                }));
        }
    }

    const chevronLeftHandler = () => {
        if (active === 1) {
            setActive(3);
        } else {
            setActive(active - 1);
        }
    }
    const chevronRightHandler = () => {
        if (active === 3) {
            setActive(1);
        } else {
            setActive(active + 1)
        }
    }

    return (
        <>
            <h1 className="text-center">Was trifft auf Sie zu?</h1>
            <div className={styles.cardContainer}>
                <FaChevronLeft onClick={chevronLeftHandler} className={styles.switchIconsLeft} size={20}/>
                <div className={styles.cards}>
                    {companyTypes.map((t, i) => (
                        <div
                            key={t.id}
                            className={getClassName(t.id)}
                            onClick={() => setActive(t.id)}
                        >
                            <div className="d-flex justify-content-center gap-4">
                                <FormCheck 
                                    onChange={e => checkboxHandler(e.target.checked, t)}
                                    checked={data.company_type === t.type && data.x_is_house_management === t.x_is_house_management}
                                />
                                <h5>{t.title}</h5>
                                <span></span>
                            </div>
                            <p>{t.desc}</p>
                            <p>{t.foot}</p>
                            <div className="text-end">
                                <FaInfoCircle size={25}/>
                            </div>
                        </div>
                    ))}
                </div>
                <FaChevronRight onClick={chevronRightHandler} className={styles.switchIconsRight} size={20} />
            </div>
        </>
    )
}
export default CompanyTypeCards;